import React, { useState, useEffect, useContext } from 'react';
import '../App.css';
import { Form, FormGroup, Button, Input } from 'reactstrap';
import user from '../assets/user.png';
import MyLoader from './util/loader';
import MyError from './util/error';
import MyStorage from './util/storage';
import Api from './api/api';
import showToast from './util/toast';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthContext } from '../context/AuthContext';

const AdminProfile = () => {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [showPass, setShowPass] = useState(false)
    const [showError, setShowError] = useState(false);
    const [error, setError] = useState('');
    const [loader, setLoader] = useState(false);

    const {user, setUser} = useContext(AuthContext)

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        console.log('load data');
        setEmail(user.email)
    };

    const updateLogin = () => {
        if (email === '') {
            setShowError(true)
            setError('Email empty!')
            return
        }
        setShowError(false)
        setError('')
        setLoader(true)
        Api.updateAdmin(email, password,
            (response) => {
                setLoader(false)
                let user = MyStorage.getUser()
                user.email = email
                setUser(user)
                showToast('success', 'Profile Updated!')
            },
            (error) => {
                setLoader(false)
            });
    };

    return (
        <div className='main'>
            <div className='titlebar' style={{ backgroundColor: '#f2f2f2', padding: 10, margin: -15 }}>
                <div style={{ color: 'blue' }}>
                    Admin Profile
                </div>
            </div>
            <div style={{ marginTop: 15, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <img
                    src={user}
                    style={{ width: 100, height: 100, marginBottom: 20, marginTop: 20 }} />
                <Form className="form" style={{ width: 500 }}>
                    <FormGroup>
                        <Input
                            type='email'
                            placeholder='Email'
                            value={email}
                            onChange={(event) => {
                                console.log('change: ' + event.target.value);
                                setEmail(event.target.value)
                            }} />
                    </FormGroup>
                    <FormGroup
                        style={{ marginTop: 10, display: 'flex', alignItems: 'center' }}>
                        <Input
                            type={showPass ? 'text' : 'password'}
                            placeholder='New Password'
                            autoComplete="off"
                            value={password}
                            onChange={(event) => {
                                console.log('change: ' + event.target.value);
                                setPassword(event.target.value)
                            }} />
                        <div
                            style={{ color: 'blue', marginLeft: 10 }}
                            onClick={() => {
                                setShowPass(!showPass)
                            }}>
                            {showPass ? 'Hide' : 'Show'}
                        </div>
                    </FormGroup>

                    <MyError showError={showError} error={error} />

                    <Button
                        style={{ marginTop: 20, fontSize: 16 }}
                        className='btn-block btn-dark'
                        onClick={() => {
                            updateLogin()
                        }}>
                        Update Admin Login
                    </Button>
                </Form>
            </div>
            <MyLoader loader={loader} />
            <div>
                <ToastContainer />
            </div>
        </div>
    );
}

export default AdminProfile;